export default __webpack_public_path__ + "static/media/tail-spin-retail-blue.1e1a7cfa.svg";